import type { ReactElement } from "react";
import React from "react";
import { Link } from "react-router-dom";
import { SeoHelmet } from "components/common";

export default function PageNotFound(): ReactElement {
	return (
		<div className="wrapper">
			<SeoHelmet title="Not Found - Brick Me" />
			<div className="box-cont">
				<h3>
					<span style={{ color: "#f7b907" }}>◼</span> 404 Not Found
				</h3>
				<h4>
					The page or file you&apos;re looking for is no longer available.
				</h4>
				<div className="line-divider" />
				<p>
					You may want to head back to the homepage. If you think something is
					broken, please report a problem.
				</p>
				<div className="btn-cont">
					<Link to="/" className="btn">
						Go to homepage
					</Link>
				</div>
			</div>
		</div>
	);
}
